module.exports = __webpack_public_path__ + "img/WetSkyline.daaf2857.jpg";